import {
  GET_SERVICEINIT_PAGE,
  SET_SERVICEINIT_PAGE,
  SET_SERVICEINIT_MENU,
  SET_SPINNER_STATUS,
  SET_MENU_INDEX,
  REFRESH_MENUS,
  IS_LOADING_BATCH,
  SUBMIT_BATCH_INIT_SUCCESS,
  BATCH_INIT_PROGRESS_SUCCESS,
  BATCH_INIT_SET_ERRORS,
  BATCH_INIT_SHOW_HIDE_ERRORS,
} from './serviceInitTypes';
import {
  loadServiceInitiation,
  fetchNewServiceInitiation,
  uploadBatchServiceInitiations,
  downloadTemplateAPI,
  getBatchInitProgressAPI,
} from 'src/services/serviceinit.service.js';
import { deriveMenuAndIndex } from './serviceInitReselect';
import { push } from 'react-router-redux';
import { saveAs } from 'file-saver';
import intl from 'react-intl-universal';
import { showNotification } from 'src/utils/utilsActions';
import { SERVICEINIT_LANDING_URL } from 'src/constants/constants.js';

export const setServiceInitPage = payload => ({
  type: SET_SERVICEINIT_PAGE,
  payload,
});

export const setServiceInitMenu = payload => ({
  type: SET_SERVICEINIT_MENU,
  payload,
});

export const refreshMenus = payload => ({
  type: REFRESH_MENUS,
  payload,
});

export const setMenuIndex = payload => ({
  type: SET_MENU_INDEX,
  payload,
});

export const updateMenuIndex = menuIndex => {
  return async dispatch => {
    dispatch(setMenuIndex({ menuIndex }));
  };
};

export const resumeServiceInit = entityId => {
  return async (dispatch, getState) => {
    dispatch({ type: GET_SERVICEINIT_PAGE });
    const response = await loadServiceInitiation(entityId);
    if (response && response.success) {
      dispatch(setServiceInitPage({ ...response, entityId }));
      const newMenu = deriveMenuAndIndex(null, false)(getState());
      dispatch(setServiceInitMenu(newMenu));
    }
  };
};

export const getServiceInitPage = body => {
  return async (dispatch, getState) => {
    dispatch({ type: GET_SERVICEINIT_PAGE });
    const response = await fetchNewServiceInitiation();
    if (response && response.success) {
      dispatch(setServiceInitPage(response));
      const newMenu = deriveMenuAndIndex(body.pageId, body.complete || false)(getState());
      dispatch(setServiceInitMenu(newMenu));
      // because the initial route /ssi/add is a static page we will update the URL
      // to the correctly generated dynamic URL after API response
      if (typeof body.pageId === 'undefined') {
        dispatch(push(newMenu.menu[0].url));
      }
    }
  };
};

export const updateMenu = (menus, body) => {
  return async (dispatch, getState) => {
    dispatch(refreshMenus(menus));
    const newMenu = deriveMenuAndIndex(body.pageId, body.complete || false)(getState());
    dispatch(setServiceInitMenu(newMenu));
  };
};

export const toggleSpinner = isLoading => ({
  type: SET_SPINNER_STATUS,
  isLoading,
});

export const uploadBatchInitiations = (file, callback) => {
  return async dispatch => {
    const formData = new FormData();
    formData.append('files', file);

    dispatch(isLoading(IS_LOADING_BATCH, true));
    dispatch(
      getBatchInitProgressSuccess({
        status: 'Uploading',
        progress: 0,
      }),
    );
    await uploadBatchServiceInitiations(formData).then(response => {
      if (response && !response.error) {
        dispatch(uploadBatchInitiationsSuccess({ importId: response }));
        dispatch(showNotification(intl.get('serviceInit.batchInit.successMessage'), { variant: 'success' }));
        callback(response);
      } else {
        if (response && response.error && response.error.message) {
          dispatch(showNotification(response.error.message, { variant: 'error' }));
        } else {
          dispatch(showNotification(intl.get('serviceInit.batchInit.uploadError'), { variant: 'error' }));
        }
        dispatch(isLoading(IS_LOADING_BATCH, false));
      }
    });
  };
};

export const uploadBatchInitiationsSuccess = data => ({
  type: SUBMIT_BATCH_INIT_SUCCESS,
  data,
});

export const downloadBatchTemplate = () => {
  return async dispatch => {
    await downloadTemplateAPI().then(res => {
      if (res) {
        // Check for error
        var decodedString = String.fromCharCode.apply(null, new Uint8Array(res));
        var errorEncountered = false;
        try {
          var obj = JSON.parse(decodedString);
          if (obj.error) errorEncountered = true;
        } catch (e) {
          errorEncountered = false;
        }

        if (!errorEncountered) {
          // Download file
          var blob = new Blob([res], { type: 'application/octet-stream' });
          var filename = 'Batch Initiation Template.xlsx';
          saveAs(blob, filename);
        } else {
          dispatch(showNotification(intl.get('serviceInit.batchInit.downloadError'), { variant: 'error' }));
        }
      }
    });
  };
};

export const isLoading = (type, isLoading) => {
  return {
    type,
    isLoading,
  };
};

export const getBatchInitProgress = (importId, callback) => {
  return async (dispatch, getState) => {
    const response = await getBatchInitProgressAPI({ importId });

    if (response && response.status && !response.error) {
      let importProgress = 0;
      switch (response.status) {
        case 'Submitted':
          importProgress = 0;
          break;
        case 'Parsing':
          importProgress = 25;
          break;
        case 'Transforming':
          importProgress = 50;
          break;
        case 'Importing':
          importProgress = 75;
          break;
        case 'Completed':
          importProgress = 100;
          dispatch(isLoading(IS_LOADING_BATCH, false));
          dispatch(showNotification(intl.get('serviceInit.batchInit.completedMessage')));
          callback();
          dispatch(push(SERVICEINIT_LANDING_URL));
          break;
        case 'Failed':
          importProgress = 100;
          dispatch(isLoading(IS_LOADING_BATCH, false));

          if (!response.success) {
            dispatch(setErrorsDialog(true, response));
          }

          callback();
          break;
        default:
          break;
      }

      dispatch(
        getBatchInitProgressSuccess({
          status: response.status,
          progress: importProgress,
        }),
      );
    } else {
      dispatch(showNotification('Failed to get import progress.', { variant: 'error' }));
      dispatch(isLoading(IS_LOADING_BATCH, false));
      callback();
    }
  };
};

export const getBatchInitProgressSuccess = data => ({
  type: BATCH_INIT_PROGRESS_SUCCESS,
  data,
});

export const setErrorsDialog = (showErrors, errors) => {
  return {
    type: BATCH_INIT_SET_ERRORS,
    showErrors,
    errors,
  };
};

export const showHideErrorDialog = showErrors => {
  return async (dispatch, getState) => {
    dispatch({
      type: BATCH_INIT_SHOW_HIDE_ERRORS,
      showErrors,
    });
  };
};
